export default {
  getAppid: {
    url: 'auth/getAppid',
    method: 'post'
  },
  sendValidCode: {
    url: '/tjd-resource/sms/endpoint/send-validate',
    method: 'post',
    param: true
  },
  validateMessage: {
    url: '/tjd-resource/sms/endpoint/validate-message',
    method: 'post',
    param: true
  }
}
